import { Tooltip } from 'bootstrap';

export default {
    mounted(el) {
        el._tooltipInstance = new Tooltip(el);
    },
    unmounted(el) {
        if (el._tooltipInstance) {
            el._tooltipInstance.dispose();
            delete el._tooltipInstance;
        }
    }
};
